<div>{{ candidate.source }}</div>
<div class="small" placement="bottom" ngbTooltip="STORE ID">{{ candidate.storeIdentifier }}</div>
